export default [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Truck",
		value: "truck_number",
		func: true,
		valueFilter: 'filter_truck_number',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer_number",
		func: true,
		valueFilter: 'filter_trailer_number',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer type",
		value: "trailer_type",
		func: true,
		valueFilter: 'filter_trailer_type',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Driver",
		value: "driver",
		func: true,
		valueFilter: 'filter_driver',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: true,
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "ELD",
		value: "eld",
		func: true,
		valueFilter: 'filter_eld',
		model: { value: 'list' },
		sortable: true,
		modText: true,
	},
	{
		settings: true,
		text: "Next alignment date",
		value: "alignment_date",
		func: true,
		valueFilter: 'filter_alignment_date',
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Next annual inspection date",
		value: "annual_inspection_date",
		func: true,
		valueFilter: 'filter_annual_inspection_date',
		model: { value: 'date' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Next PM",
		value: "pm_date",
		func: true,
		valueFilter: 'filter_pm_date',
		model: { value: 'number' },
		sortable: true,
		miles: true
	},
	{
		settings: true,
		text: "Company owned",
		func: true,
		value: "company_owner",
		valueFilter: 'filter_company_owner',
		model: { value: 'list' },
		sortable: true,
		modText: true,
		align: 'center',
	},
	{
		settings: true,
		text: "Active",
		func: true,
		value: "active",
		valueFilter: 'filter_active',
		model: { value: 'list' },
		sortable: true,
		modText: true,
		align: 'center',
	},
	{
		settings: true,
		text: "Left the company",
		func: true,
		value: "left_company",
		valueFilter: 'filter_left_company',
		model: { value: 'list' },
		sortable: true,
		modText: true,
		align: 'center',
		toLeft: true,
	},
	{
		settings: true,
		text: "Sold",
		func: true,
		value: "sold",
		valueFilter: 'filter_sold',
		model: { value: 'list' },
		sortable: true,
		modText: true,
		align: 'center',
		toLeft: true,
	},
	{
		settings: true,
		text: "Status",
		func: true,
		value: "truck_status",
		valueFilter: 'filter_truck_status',
		model: { value: 'list' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'edit',
				text: 'Edit truck',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: { or: [ 11 ] },
				value: 'delete',
				text: 'Delete truck',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
